import { Dropdown } from "react-bootstrap";
import trash from "../../assets/trash.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { itemsService } from "../../services/items.service";
import LogicContext from "../../Context/LogicContext";
import { useEffect, useMemo } from "react";
import { useState } from "react";
import { useContext } from "react";
import {
  SetTItemList,
  GetItemList,
  SettItemBackupList,
  GetItemBackupList,
  ResetItemToEdit,
} from "../../store/itemAtom";
import underscore from "underscore";
import CsvDownload from "react-json-to-csv";
// import "../pages/ItemPage.css";
import Tooltip from "@mui/material/Tooltip";

import { FaTrashAlt } from "react-icons/fa";
import { IoMdRefresh } from "react-icons/io";

import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import StatusBadge from "../../generals/StatusBadge";
import { Modal } from "antd";
import ItemSkuQrCode from "./ItemSkuQrCode";
import { MdQrCode } from "react-icons/md";

const getItemSku = (row) => row?.Item_Sku ?? row?.item_sku ?? "";

const buildQrColumn = (onOpen) => ({
  title: "QR",
  key: "qr",
  width: 60,
  render: (_, row) => {
    const sku = getItemSku(row);
    if (!sku) return <span className="text-gray-300">—</span>;
    return (
      <Tooltip title="View QR code">
        <span
          onClick={(e) => {
            e.stopPropagation();
            onOpen(row);
          }}
          className="cursor-pointer inline-flex p-1 rounded hover:bg-gray-100"
        >
          <MdQrCode className="h-5 w-5 text-gray-700" />
        </span>
      </Tooltip>
    );
  },
});

const columns = [
  {
    title: 'Id',
    key: 'Item_Id',
    dataIndex: 'Item_Id',
    sorter: (a, b) => (a?.Item_Id ?? '') - (b?.Item_Id ?? '')
    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },
  {
    title: 'Name',
    key: 'Item_Name',
    dataIndex: 'Item_Name',
    className: "text-primary",
    sorter: (a, b) => (a?.Item_Name ?? '').localeCompare(b?.Item_Name ?? '')
    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },
  {
    title: 'Category',
    dataIndex: 'Item_Category_Name',
    sorter: (a, b) => (a?.Item_Category_Name ?? '').localeCompare(b?.Item_Category_Name ?? '')
    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },
  {
    title: 'Unit',
    dataIndex: 'Item_Unit_Name',
    sorter: (a, b) => (a?.Item_Unit_Name ?? '').localeCompare(b?.Item_Unit_Name ?? '')
  },
 
 
  {
    title: 'Sales Rate',
    dataIndex: 'Sales_Rate',
    sorter: (a, b) => (a?.Sales_Rate ?? '') - (b?.Sales_Rate ?? ''),
            render: (record) => <span> {formatCustomNumber(record)} </span> ,
  },

  {
    title: 'ReOrder Qty',
    dataIndex: 'Reorder_Quantity',
    sorter: (a, b) => (a?.Reorder_Quantity ?? '') - (b?.Reorder_Quantity ?? ''),
            render: (record) => <span> {formatCustomNumber(record)} </span> ,
          },
          
          {
            title: 'Status',
            dataIndex: 'Item_Status_Name',
            sorter: (a, b) => (a?.Item_Status_Name ?? '').localeCompare(b?.Item_Status_Name ?? ''),
            render: (record, row) => (
              <StatusBadge statusId={row?.Item_Status_Id} statusName={record} />
            ),
  },



];




function ItemPage() {
  const logicContext = useContext(LogicContext);
  const resetItemToEdit = ResetItemToEdit();
  const [itemSelected, setItemSelected] = useState([]);
    const navigate = useNavigate();
  const setItemListState = SetTItemList();
  const setItemBackupList = SettItemBackupList();
  const itemAtomData = GetItemList();
  const itemMasterList = GetItemBackupList();
  const myPromiseModal = createModal(GeneralModal);
  const [qrItem, setQrItem] = useState(null);
  const [searchText, setSearchText] = useState("");

  const filteredItems = useMemo(() => {
    const list = itemAtomData?.item_info ?? [];
    const term = searchText.trim().toLowerCase();
    if (!term) return list;
    const fields = [
      "Item_Id", "Item_Name", "Item_Sku", "item_sku", "Item_Category_Name",
      "Item_Unit_Name", "Item_Status_Name", "Sales_Rate",
    ];
    return list.filter((item) =>
      fields.some((f) => String(item?.[f] ?? "").toLowerCase().includes(term))
    );
  }, [itemAtomData, searchText]);

  const tableColumns = [
    ...columns.slice(0, 2),
    buildQrColumn(setQrItem),
    ...columns.slice(2),
  ];



  useEffect(() => {
    document.title = "Item Page";

   return ()=> {
    resetItemToEdit();
   }
  }, []);

  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  useEffect(() => {
    if (itemAtomData.item_info.length < 1) {
      itemsService.getItemsList().then((res) => {
        if (res?.data) {
          setItemListState(res?.data);
          setItemBackupList(res?.data);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemAtomData]);

  function loadItemsFromServer() {
    itemsService .getItemsList().then((res) => {
        if (res?.data?.item_info.length > 0) {
          setItemListState(res?.data);
          setItemBackupList(res?.data);
        }
      })
      .catch((err) => console.log(err));
  }

  function customFilter(value) {
  
    if (value === "All") {
      return setItemListState(itemMasterList);
    }

    if (value === "Item_Id") {
      var temp = underscore.sortBy(itemAtomData.item_info, value);
      var temp2 = temp.reverse();
      setItemListState({itemAtomData, item_info:temp2});
    } else {
      var customFilter = underscore.sortBy(itemAtomData.item_info, value);
      setItemListState({itemAtomData, item_info:customFilter});
    }
  }

  function handleRowClick(item) {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/item-details/${item?.Item_Id}`
    );
  }


  function filterItemReturnable(status) {
    var customFilter = itemMasterList?.item_info.filter(
      (item) => item.Item_Returnable_Name === status
    );
    if (customFilter?.length) {
      setItemListState({itemAtomData, item_info:customFilter});
    } else {
      setItemListState({itemAtomData, item_info:[]});
    }
  }

  function filterByVariety(code) {
    var customFilter = itemMasterList?.item_info.filter(
      (item) => item.Item_Variety_Id === code
    );
    if (customFilter?.length) {
      setItemListState({itemAtomData, item_info:customFilter});
    } else {
      setItemListState({itemAtomData, item_info:[]});
    }
  }

  function filterByCategory(code) {
    var customFilter = itemMasterList?.item_info.filter(
      (item) => item.Item_Category_Id === code
    );
    if (customFilter?.length) {
      setItemListState({itemAtomData, item_info:customFilter});
    } else {
      setItemListState({itemAtomData, item_info:[]});
    }
  }

  function filterIventoryItems(status) {
    var customFilter = itemMasterList?.item_info.filter(
      (item) => item.Item_Tracking_Need_Name === status
    );
    if (customFilter?.length) {
      setItemListState({itemAtomData, item_info:customFilter});
    } else {
      setItemListState({itemAtomData, item_info:[]});
    }
  }

  function selectedItems(itemList) {
    setItemSelected(itemList);
  }

  function setItemToActive() {
    var xmlString = "";
    itemSelected?.map((item) => {
      xmlString += `<a><refno>${item.Item_Id} </refno></a>`;
    });

    itemsService
      .setItemActive(`<root> ${xmlString} </root>`)
      .then((res) => {
        loadItemsFromServer();
      })
      .catch((err) => console.log("err ", err));
  }

  function setItemToInActive() {
    var xmlString = "";
    itemSelected?.map((item) => {
      xmlString += `<a><refno>${item.Item_Id} </refno></a>`;
    });

    itemsService
      .setIteminActive(`<root> ${xmlString} </root>`)
      .then((res) => {
        loadItemsFromServer();
      })
      .catch((err) => console.log("err ", err));
  }

 async  function deleteItems() {
    await myPromiseModal({
      title: "Confirmation",
      body: `${itemSelected?.length} will be deleted!`,
      showInput: false,
      placeHolder: "",
    }).then((response) => {
      if (response.decision === true) {
        // delete confirmed
        var xmlString = "";
        itemSelected?.map((item) => { xmlString += `<a><refno>${item.Item_Id} </refno></a>` });
    
        itemsService.deleteItems(`<root> ${xmlString} </root>`).then((res) => {
          loadItemsFromServer();
        }) .catch((err) => console.log("err ", err));



        // End delete confirmed
        
      }
    });
 
  }

  const paginationOptions = {
    pageSize: 10,
    showSizeChanger: true,
    total: filteredItems.length,
  };


  return (
    <div className="@container">
      <div className="@xl:flex @xl:justify-between ">
        <div className="mt-4 flex">
          <div className="flex rounded bg-filterColor ">
            <Dropdown>
              <Dropdown.Toggle
                style={{
                  backgroundColor: "#E5E5E5",
                  border: "none",
                  color: "#45444B",
                  fontSize: "12px",
                  height: "35px",
                }}
                id="dropdown-basic"
              >
                FILTER BY
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item onClick={() => customFilter("All")}>
                  All
                </Dropdown.Item>

                <Dropdown.Item onClick={() => filterByVariety(2)}>
                  Composite Items
                </Dropdown.Item>

                <Dropdown.Item onClick={() => filterByVariety(1)}>
                  SIngle Items
                </Dropdown.Item>

                <Dropdown.Item onClick={() => filterByCategory(1)}>
                  Raw Materials
                </Dropdown.Item>

                <Dropdown.Item onClick={() => filterByCategory(2)}>
                  Packing Materials
                </Dropdown.Item>

                {/* <Dropdown.Item onClick={() => customFilterByStatus("Active")}>
                  Active Items
                </Dropdown.Item>

                <Dropdown.Item onClick={() => customFilterByStatus("Inactive")}>
                  InActive Items
                </Dropdown.Item> */}

                <Dropdown.Item onClick={() => filterIventoryItems("Yes")}>
                  Inventory Items
                </Dropdown.Item>

                <Dropdown.Item onClick={() => filterIventoryItems("No")}>
                  Non Inventory Items
                </Dropdown.Item>

                <Dropdown.Item onClick={() => filterItemReturnable("No")}>
                  Non Returnable Items
                </Dropdown.Item>

                <Dropdown.Item onClick={() => filterItemReturnable("Yes")}>
                  Returnable Items
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <Tooltip title="Reload">
            <div
              onClick={() => loadItemsFromServer()}
              className="group ml-2 flex items-center justify-center px-2 border-[1px] border-gray-200 bg-white rounded-md hover:bg-gray-200 cursor-pointer"
            >
              <IoMdRefresh className="h-6 w-6 text-gray-600 group-active:rotate-45 transition-all duration-300" />
            </div>
          </Tooltip>

          <div className="relative ml-2">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"
              className="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none">
              <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
            </svg>
            <input
              type="text"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Search name, SKU, ID..."
              className="h-[35px] w-56 rounded-md border border-gray-200 bg-white pl-8 pr-7 text-sm text-gray-800 placeholder-gray-400 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            />
            {searchText && (
              <button
                type="button"
                onClick={() => setSearchText("")}
                className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 text-sm"
                aria-label="Clear search"
              >
                ×
              </button>
            )}
          </div>
        </div>

        <div className="flex items-center">
          {itemSelected.length > 0 ? (
            <div className="mt-4 flex flex-row items-center space-x-2">
              <Tooltip title="Active">
                <button
                  onClick={() => setItemToActive()}
                  className="text-gray-600 text-sm font-medium px-4 py-2.5 bg-gray-200 border-[1px] border-gray-300 rounded-md focus:outline-none hover:bg-gray-100 active:bg-gray-200 transition-all duration-200"
                >
                  ACTIVE
                </button>
              </Tooltip>
              <Tooltip title="Inactive">
                <button
                  onClick={() => setItemToInActive()}
                  className="text-gray-600 text-sm font-medium px-4 py-2.5 bg-gray-200 border-[1px] border-gray-300 rounded-md focus:outline-none hover:bg-gray-100 active:bg-gray-200 transition-all duration-200"
                >
                  INACTIVE
                </button>
              </Tooltip>
              <Tooltip title="Delete">
                <button
                  onClick={() => deleteItems()}
                  className="px-6 py-[11.5px] bg-gray-200 border-[1px] border-gray-300 rounded-md text-white focus:outline-none font-medium hover:bg-gray-100 active:bg-gray-200 transition-all duration-200"
                >
                  <FaTrashAlt className="h-[16px] w-[16px] text-gray-600" />
                </button>
              </Tooltip>

              {/* <button className=" bg-filterColor rounded text-black text-sm font-[Poppins] py-2 mt-1  px-3">
                Import
              </button>

              <button className="bg-filterColor mx-2 rounded text-black text-sm font-[Poppins] mt-1 py-[1.8vh]  px-3">
                Export
              </button> */}
            </div>
          ) : null}

          <Link
            to={`/${currModuleId}/${currModuleName}/${currUserMenu}/add-item/${1}`}
          >
            <button className="mt-4 py-2.5 px-6 text-sm rounded-md bg-blue-500 text-white font-medium focus:outline-none">
              Add New
            </button>
          </Link>
        </div>
      </div>

      {/*  Table here... */}
      <div className="mt-5">
    
        <GeneralCustomTable
                   tableHeadList={tableColumns}
                   tableDataList={filteredItems}
                  allowCheckBox={true} // show checkBox for each row
                  setSelectedRows={selectedItems}
                  paginationOptions={paginationOptions} 
                  rowKey={(record) => record.Item_Id} // custom key
                  handleRowClick={handleRowClick} />
      </div>

      <Modal
        open={!!qrItem}
        onCancel={() => setQrItem(null)}
        footer={null}
        centered
        destroyOnClose
        title={qrItem?.Item_Name}
      >
        <div className="flex justify-center py-4">
          <ItemSkuQrCode sku={getItemSku(qrItem)} name={qrItem?.Item_Name} size={280} />
        </div>
      </Modal>
    </div>
  );
}

export default ItemPage;
